import { useContext, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { UpdateOrderDeliveryPickupModalContext } from "../../Account/useUpdateOrderDeliveryModal/deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
import { TabValues } from "../../Account/useUpdateOrderDeliveryModal/deliveryModalUtils/const-enums-types";
import { useOrderFlow } from "../../OrderFlow/OrderFlowProvider/OrderFlowContext";
import { useModal } from "../../Shared/components/Modal";
import useToast from "../../hooks/useToast";
import { CheckoutContext } from "../CheckoutContext";
import { DeliverySectionText } from "./DeliveryMethodSection-types";
import { updateLocationFunction } from "./DeliveryMethodSectionUtils";
import { OrderType } from "../../Shared/sharedTypes/OrderInfoInterface";
export const useDeliveryMethodSection = (locations) => {
    var _a, _b, _c;
    const { getValues, setValue, clearErrors, getFieldState, formState } = useFormContext();
    const { closeModal } = useModal();
    const toast = useToast();
    const location = useLocation();
    const navigate = useNavigate();
    const { store, dispatch } = useOrderFlow();
    const { customerShippingAddresses, orderInfo } = useContext(CheckoutContext);
    const { setLoading, setIsModalOpen: setContextIsModalOpen } = useContext(UpdateOrderDeliveryPickupModalContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openCloseModal = (open) => {
        setIsModalOpen(open);
        setContextIsModalOpen(open);
    };
    //ensure address matches postal code in model
    const addressToUse = (_a = customerShippingAddresses === null || customerShippingAddresses === void 0 ? void 0 : customerShippingAddresses.find((a) => a.addressId === getValues("address") && a.zip === store.model.PostalCode)) !== null && _a !== void 0 ? _a : undefined;
    const locationToUse = locations === null || locations === void 0 ? void 0 : locations.find((l) => l.locationSku === getValues("location"));
    const isDeliveryOrder = !!store.model.PostalCode && (orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.OrderType) === OrderType.Delivery;
    const initTabProps = {
        initTabValue: isDeliveryOrder ? TabValues.DELIVERY : TabValues.PICKUP,
        initDeliveryLocation: (_b = addressToUse === null || addressToUse === void 0 ? void 0 : addressToUse.addressId.toString()) !== null && _b !== void 0 ? _b : undefined,
        initPickupLocation: (_c = locationToUse === null || locationToUse === void 0 ? void 0 : locationToUse.locationSku) !== null && _c !== void 0 ? _c : undefined,
        isCheckout: true,
    };
    let buttonText = isDeliveryOrder
        ? DeliverySectionText.CHANGE_DELIVERY_ADDRESS
        : DeliverySectionText.CHANGE_LOCATION;
    if (isDeliveryOrder && !addressToUse) {
        buttonText = DeliverySectionText.ADD_DELIVERY_ADDRESS;
    }
    const { error: addressError } = getFieldState("address", formState);
    const { error: locationError } = getFieldState("location", formState);
    return {
        isDeliveryOrder,
        addressToUse,
        locationToUse,
        openCloseModal,
        buttonText,
        addressError,
        locationError,
        isModalOpen,
        setIsModalOpen,
        orderInfo,
        initTabProps,
        getValues,
        updateFunction: updateLocationFunction(setValue, clearErrors, closeModal, toast, location, locations, dispatch, setLoading, openCloseModal, navigate),
    };
};
